import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="Breadcrumb" className="w-full px-4 md:px-6 lg:px-8 py-4">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={index} className="flex items-center gap-1">
              {index > 0 && (
                <span className="text-foreground-400 mx-1">
                  <i className="ri-arrow-right-s-line text-sm"></i>
                </span>
              )}
              {item.to && !isLast ? (
                <Link
                  to={item.to}
                  className="text-foreground-500 hover:text-accent-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  {item.label}
                </Link>
              ) : (
                <span className={`whitespace-nowrap ${isLast ? 'text-foreground-800 font-medium' : 'text-foreground-500'}`}>
                  {item.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}